import {
  Avatar,
  Box,
  Button,
  Chip,
  Divider,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import Avtarplaceholder from "../../assets/images/avtar_placeholder.jpeg";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import EditIcon from "@mui/icons-material/Edit";
import { Getrequestcall } from "../../request/Getrequest";
import { GETUSERINFO, SAVE_PERSONAL_INFO } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import Loader from "../../common/Loader";
import { English } from "../../constant/EnglishFallback";
import PictureViewer from "../common/PictureViewer";
import { setShowalert } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";

export default function Editprofile({
  showProfile,
  handleClose,
  getUserInfo,
  setShowTrade,
  trades,
  handleTradeModal,
  setEditedTab,
  resetTradeLoading
}) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isModified, setIsModified] = useState(false);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [isTradeLoading, setIsTradeLoading] = useState(false);
  const isReturningFromTrade = useRef(false);
  const [profile, setProfile] = useState({
    imageFile: "",
    selectedFile: "",
    firstName: "",
    lastName: "",
    userEmail: ""
  });
  const {
    BUTTON_ADD_MY_TRADE = English?.Profile?.BUTTON_ADD_MY_TRADE,
    TEXT_EDIT_PROFILE = English?.Profile?.TEXT_EDIT_PROFILE,
    TEXT_PROFILE_PICTURE = English?.Profile?.TEXT_PROFILE_PICTURE,
    BUTTON_CHANGE_PROFILE_PIC = English?.Profile?.BUTTON_CHANGE_PROFILE_PIC,
    TEXT_NAME = English?.Profile?.TEXT_NAME,
    TEXT_TRADE = English?.Profile?.TEXT_TRADE,
    TEXT_SIMILAR_TRADE_DESC = English?.Profile?.TEXT_SIMILAR_TRADE_DESC,
    TEXT_FIRST_NAME = English?.Profile?.TEXT_FIRST_NAME,
    TEXT_LAST_NAME = English?.Profile?.TEXT_LAST_NAME,
    TEXT_LAST_NAME_LARGE = English?.Profile?.TEXT_LAST_NAME_LARGE,
    TEXT_FIRST_NAME_LARGE = English?.Profile?.TEXT_FIRST_NAME_LARGE
  } = multiLanguageData?.Profile || {};

  useEffect(() => {
    if (showProfile) {
      if (!isReturningFromTrade.current) {
        getUserinfo();
        setIsTradeLoading(false);
      }
    }
  }, [showProfile]);

  // Expose reset function to parent
  useEffect(() => {
    if (resetTradeLoading && typeof resetTradeLoading === 'function') {
      resetTradeLoading(() => {
        setIsTradeLoading(false);
        isReturningFromTrade.current = false;
      });
    }
  }, []);

  // Reset loading when trades are updated
  useEffect(() => {
    if (isTradeLoading && trades?.length >= 0) {
      setIsTradeLoading(false);
      isReturningFromTrade.current = false;
    }
  }, [trades]);

  const getUserinfo = async () => {
    setIsLoading(true);
    try {
      let getResponse = await Getrequestcall(
        `${GETUSERINFO}/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );
      if (getResponse?.status === 200) {
        let getDetail = getResponse?.data?.data;
        setProfile({
          ...profile,
          firstName: getDetail?.firstName,
          lastName: getDetail?.lastName,
          selectedFile: getDetail?.pictureUrl,
          userEmail: getDetail?.userEmail
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log("getUserinfo-> Error While Getting User Information: ", error);
      setIsLoading(false);
    }
  };

  const handleChooseFile = (event) => {
    setIsModified(true);
    const file = event.target.files[0];
    if (file) {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        alert("File type not supported. Please select an image.");
      } else {
        setProfile({
          ...profile,
          imageFile: event.target.files[0],
          selectedFile: URL.createObjectURL(event.target.files[0])
        });
      }
    }
  };

  const handleInputchange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z]+|(?<=\b\w)[^A-Za-z0-9\s]/g, "");
    setIsModified(true);
    setProfile({
      ...profile,
      [e.target.name]: inputValue
    });
  };

  const onSaveprofile = async () => {
    if (profile?.firstName?.length > 100) {
      let alertObj = {
        showAlert: true,
        title: "",
        text: TEXT_FIRST_NAME_LARGE
      };
      dispatch(setShowalert(alertObj));
      return;
    } else if (profile?.lastName?.length > 100) {
      let alertObj = {
        showAlert: true,
        title: "",
        text: TEXT_LAST_NAME_LARGE
      };
      dispatch(setShowalert(alertObj));
      return;
    }
    handleTradeModal("edit profile");
    setIsLoading(true);

    try {
      const formData = new FormData();
      formData.append("Id", loginData?.userInformation?.UserId);
      formData.append("FirstName", profile?.firstName);
      formData.append("UserEmail", profile.userEmail);
      formData.append("LastName", profile?.lastName);
      formData.append("ModifiedBy", loginData?.userInformation?.UserId);
      formData.append("PictureUrl", profile.imageFile);

      const getResponse = await Fileuploadrequestcall(
        SAVE_PERSONAL_INFO,
        formData,
        loginData?.accessToken
      );
      if (getResponse?.status === 201) {
        getUserInfo();
        handleClose();
      } else if (getResponse?.status === 400) {
        let alertObj = {
          showAlert: true,
          text: "Profile name is too long. Please keep it under 100 characters."
        };
        dispatch(setShowalert(alertObj));
      }

      setIsModified(false);
    } catch (error) {
      setIsLoading(false);
      console.log("onSaveprofile-> Error While Updating Profile Data: ", error);
    }
  };

  const handleShowTrade = async () => {
    isReturningFromTrade.current = true;
    setShowTrade(true);
    handleTradeModal("edit profile");
  };

  return (
    <>
      <Modal
        open={showProfile}
        disableEnforceFocus
        disableScrollLock
        disableAutoFocus
        disableRestoreFocus
        // onClose={handleClose}
      >
        <Box className="user-modal-responsive">
          {
            // Form body
            isLoading ? (
              <Box sx={{ justifyContent: "center",  display: "flex", height: "520px" }}>
                <Loader />
              </Box>
            ) : (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}>
                  <Typography sx={{ fontWeight: "500" }} variant="h5">
                    {TEXT_EDIT_PROFILE}
                  </Typography>
                  <Stack direction={"row"} sx={{ alignItems: "center" }}>
                    <IconButton color="primary" size="small" onClick={handleClose}>
                      <CloseIcon />
                    </IconButton>
                    <IconButton
                      disabled={!isModified || profile?.firstName == "" || profile?.lastName == ""}
                      color="primary"
                      size="small"
                      onClick={() => onSaveprofile()}>
                      <SaveIcon />
                    </IconButton>
                  </Stack>
                </Box>
                <Stack sx={{ gap: 1 }} >
                  <Typography sx={{ fontWeight: "500" }} variant="h6">
                    {TEXT_PROFILE_PICTURE}
                  </Typography>
                  <Stack  sx={{ gap: 1, alignItems: "center" }} textAlign={"center"}>
                    <Stack sx={{ alignItems: "center", justifyContent: "center" }} width={"100%"}>
                      <Avatar
                        variant="circular"
                        onClick={() => setPictureViewerOpen(true)}
                        src={
                          profile?.selectedFile === "" ? Avtarplaceholder : profile?.selectedFile
                        }
                        sx={{
                          height: {
                            xs: "100px",
                            sm: "130px",
                            md: "150px",
                            lg: "150px",
                            xl: "150px"
                          },
                          width: {
                            xs: "100px",
                            sm: "130px",
                            md: "150px",
                            lg: "150px",
                            xl: "150px"
                          }
                        }}
                      />
                    </Stack>
                    <Button
                      variant="outlined"
                      color="primary"
                      component="label"
                      startIcon={<CloudUploadIcon />}>
                      {BUTTON_CHANGE_PROFILE_PIC}
                      <input
                        type="file"
                        accept="image/*"
                        value={""}
                        onChange={handleChooseFile}
                        hidden
                      />
                    </Button>
                  </Stack>
                  <Typography sx={{ fontWeight: "500" }} variant="h6">
                    {TEXT_NAME}
                  </Typography>
                  <Stack sx={{ gap: 2 }} >
                    <TextField
                      fullWidth
                      size="small"
                      label={TEXT_FIRST_NAME}
                      // inputProps={{ maxLength: 100 }}
                      variant="outlined"
                      name="firstName"
                      value={profile?.firstName || ""}
                      onChange={handleInputchange}
                    />
                    <TextField
                      fullWidth
                      size="small"
                      label={TEXT_LAST_NAME}
                      // inputProps={{ maxLength: 100 }}
                      variant="outlined"
                      name="lastName"
                      value={profile?.lastName || ""}
                      onChange={handleInputchange}
                    />
                    <Divider />
                  </Stack>
                  <Typography sx={{ fontWeight: "500" }} variant="h6">
                    {TEXT_TRADE}
                  </Typography>
                  <Stack>
                    {isTradeLoading ? (
                      <Box sx={{ justifyContent: "center",  display: "flex", minHeight: "100px", alignItems: "center" }}>
                        <Loader />
                      </Box>
                    ) : trades.length > 0 ? (
                      <>
                        <Stack sx={{ display: "flex",  justifyContent: "space-between", maxHeight: "90px",
                            overflow: "auto " }}  direction={"row"}>
                          <Stack
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "7px",
                              alignItems: "center"
                            }}
                            direction="row"
                            spacing={0}>
                            {trades
                              ?.sort(
                                (a, b) =>
                                  a.tradeType
                                    ?.toLowerCase()
                                    .localeCompare(b.tradeType?.toLowerCase()) ||
                                  a.tradeName
                                    ?.trim()
                                    .toLowerCase()
                                    .localeCompare(b.tradeName?.trim().toLowerCase())
                              )
                              .map((item, index) => {
                                return (
                                  <Chip
                                    size="small"
                                    key={index.toString()}
                                    className="chip-lable"
                                    label={
                                      item.tradeName.length > 30
                                        ? item.tradeName?.trim()
                                        : item.tradeName?.trim()
                                    }
                                    style={{
                                      backgroundColor:
                                        item?.tradeType?.toLowerCase() == "main"
                                          ? "#083DB8"
                                          : "null",
                                      color:
                                        item?.tradeType?.toLowerCase() == "main" ? "white" : "null"
                                    }}></Chip>
                                );
                              })}
                          </Stack>
                          <Stack>
                            <IconButton
                              onClick={() => {
                                handleShowTrade();
                              }}>
                              <EditIcon sx={{ color: "#083DB8" }} />
                            </IconButton>
                          </Stack>
                        </Stack>
                      </>
                    ) : (
                      <Stack direction={"column"} sx={{ alignItems: "center" }} textAlign={"center"}>
                        <Typography sx={{ color: "gray" }}>{TEXT_SIMILAR_TRADE_DESC} </Typography>
                        <Button
                          className="action-button"
                          onClick={() => {
                            handleShowTrade();
                          }}
                          style={{ margin: "5px 0" }}>
                          {BUTTON_ADD_MY_TRADE}
                        </Button>
                      </Stack>
                    )}
                  </Stack>
                </Stack>
              </>
            )
          }
        </Box>
      </Modal>

      {pictureViewerOpen && (
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => setPictureViewerOpen(false)}
          src={profile?.selectedFile === "" ? Avtarplaceholder : profile?.selectedFile}
        />
      )}
    </>
  );
}

